<template>
    <v-container class="pa-5">
        <v-row align-center justify-center fill-height>
            <v-col cols="12" sm="3" lg="3" class="text-xs-center pa-3 mt-3">
                <v-responsive aspect-ratio="2/3">
                    <iframe width="280" height="158" src="https://www.youtube.com/embed/Q0amh7v8EDA?si=IC3s_fy5F9Rsotea" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                
                </v-responsive>
            </v-col>
            <v-col cols="12" sm="9" lg="9">
                <p class="google-font mb-1" style="font-weight: 350; color: #616161; font-size: 180%;">
                    <b>Cree fácilmente una página para visualizar todas sus
                        <span style="color: #1a73e8;">redes</span>.
                    </b>
                </p>
                <p class="google-font mt-0" style="font-size: 170%">{{ chapterDetails.ChapterName }}</p>
                <p class="google-font" style="font-size: 110%">{{ chapterDetails.ChapterShortDescription }}</p>

                
    <p class="google-font" style="font-size: 110%;color: #0D47A1;">Puede elegir posteriormente estas opciones:</p>

    <v-list dense two-line>
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="grey darken-1">mdi-lock</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Perfil privado</v-list-item-title>
          <v-list-item-subtitle class="text-wrap">
            Sin disponibilizar URL de perfil — especial para solo almacenar datos de links.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color="blue darken-2">mdi-link-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Perfil con acceso solo por URL</v-list-item-title>
          <v-list-item-subtitle class="text-wrap">
            Especial para usar el link en redes, sin ser listado en la vista de perfiles de TecZoa.
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color="green darken-2">mdi-earth</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Perfil público</v-list-item-title>
          <v-list-item-subtitle class="text-wrap">
            Accesible por URL y visualizado en la página principal de TecZoa.com
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>





                <p class="google-font" style="font-size: 110%; color: #9e9e9e;">
                    <span v-for="(item, i) in chapterDetails.ChapterHashTags" :key="i">
                        #{{ item }} &nbsp;
                    </span>
                </p>

               <v-btn @click="scrollToRegisterSection" class="ma-0 google-font elevation-1" color="#1a73e8" style="text-transform: capitalize; border-radius: 5px; color: white;">
          Crear un nuevo Usuario
        </v-btn>
                &nbsp;

                <v-btn @click="ingresoSection" rounded color="cyan" style="text-transform: capitalize; border-radius: 5px;" outlined class="ml-0" dark>Ingresar</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            chapterDetails: {
                ChapterName: 'Regístrese para poder gestionar fácilmente la información a disponibilizar',
                ChapterShortDescription: 'Seleccione crear un nuevo usuario, o si ya es un miembro puede seleccionar ingresar',
                ChapterHashTags: ['LinksTec', 'TecZoa', 'MagZoa'],
                ChapterMeetupLink: 'https://www.meetup.com/your-chapter',
                GDGProgramWebsite: 'https://www.google.com'
            }
        };
    },
    methods: {
    scrollToRegisterSection() {

  console.log('En componente Hijo');

         this.$emit('funcionHijoPadre');

      
      
    },
    ingresoSection() {

  console.log('En componente Hijo');

         this.$emit('funcionHijoPadreIngreso');

      
      
    }
  }
};
</script>

<style>
.google-font {
    font-family: 'Google Sans', sans-serif;
}


.text-wrap {
  white-space: normal;
  word-break: break-word;
}
</style>
